import React from 'react'
import { QuantitySelector } from 'components/item/Quantity'
import { t } from 'i18next'
import StoreItem from 'components/StoreItem'
import { SVGICONS } from 'config'

const PayForSpecificItem = ({ completeOrder, value: defaultValue = [], setValue: setDefaultValue = () => { }, split, allItems }) => {

  const handleItemClick = (item) => {
    const isSelected = defaultValue.includes(item)
    if (isSelected) {
      setDefaultValue(defaultValue.filter((i) => i !== item))
    }
    else {
      setDefaultValue([...defaultValue, item])
    }
  }

  const updateSelecetedItemQunatity = (selectedItemIndex, value) =>{
    setDefaultValue(defaultValue.map((i) => i?.uniqueId === selectedItemIndex ? { ...i, selectedQunatity: value } : i))
  }

  /**
   * Decreases the selected quantity of an item while ensuring it stays within valid bounds (minimum 1 and not exceeding available quantity).
   * @param {Object} selectedItem - The item whose quantity needs to be decreased
   * @param {number} selectedItemIndex - The index of the item in the defaultValue array
   */
  const handleDecreaseQunatity =(selectedItem, selectedItemIndex) =>{
    let value = selectedItem?.selectedQunatity - 1
    if(value < 1){
      value = 1
    }
    if(value > selectedItem?.remainingQunatity){
      value =  selectedItem?.selectedQunatity
    }
    updateSelecetedItemQunatity(selectedItemIndex, value)
  }

  /**
   * Increases the selected quantity of an item while ensuring it doesn't exceed the available quantity (total quantity minus remaining quantity).
   * @param {Object} selectedItem - The item whose quantity needs to be increased
   * @param {number} selectedItemIndex - The index of the item in the defaultValue array
   */
  const handleIncreaseQunatity = (selectedItem, selectedItemIndex)=>{
    let value = selectedItem?.selectedQunatity + 1
    if(value > selectedItem?.remainingQunatity){
      value =  selectedItem?.selectedQunatity
    }
    updateSelecetedItemQunatity(selectedItemIndex, value)
  }

  return (
    <>
      <ul>
        {allItems?.map((item, index) => {
          const selectedItem = defaultValue?.find((df) =>df?.uniqueId === item?.uniqueId) || null
          const isChecked = selectedItem?.uniqueId ===item?.uniqueId || false
          const remainingToPay = item?.quantity - item?.paidFor 
          return (
          <li
            className={`relative basket-item flex justify-between items-start flex-row flex-100 text-16x gap-2 ${
              index === allItems.length - 1 ? "" : "mb-4"
            }`}
            style={{
              minHeight: "80px",
            }}
            key={index}
          >
            <div className="flex-1 flex items-center gap-2">
              <StoreItem
                item={{ itemId: item }}
                mediaUrl={item?.mediaUrl}
                price={item?.price * item?.quantity}
                priceClass="text-16x text-brand-base-primary font-bold"
                priceContainerClassName="!justify-start gap-1"
                displayQuantityInHeader={true}
                infoContent={
                  item?.paidFor > 0 ?
                  <div className="flex flex-col">
                    <span className="text-brand-base-primary">{t("Paid Qunatity")}: <b>{item?.paidFor}</b> ✅</span>
                    {remainingToPay > 0 && <span className="text-brand-base-primary">{t("Remaing to pay")}: <b>{remainingToPay}</b></span>}
                  </div>
                  :null
                }
              />
            </div>

            <button
              onClick={() => handleItemClick(item)}>
              {isChecked ? (
                <SVGICONS.SelectCheck color="text-brand-base-primary" />
              ) : (
                <SVGICONS.SelectUnCheck color="text-brand-base-primary" />
              )}
            </button>
            <div className={`absolute ${item?.paidFor > 0 ? "bottom-0" : "bottom-1"} right-0`}>
              <QuantitySelector
                value={selectedItem?.selectedQunatity}
                increaseQuantity={() => handleIncreaseQunatity(selectedItem, item?.uniqueId)}
                decreaseQuantity={() => handleDecreaseQunatity(selectedItem, item?.uniqueId)}
                disable={!isChecked}
                showDisableMessage={false}
                wrapperStyleProps={{
                  style: { padding: "0 12px", width: "76px" },
                }}
                quantityStyleProps={{
                  style: { width: "24px", margin: "0", textAlign: "center" },
                }}
              />
            </div>
          </li>
        )})}
      </ul>
    </>
  );
}

export default PayForSpecificItem